export { FroalaViewDirective } from './view.directive';
export { FroalaViewModule } from './view.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-froala-wysiwyg/view/index.js
// module id = 527
// module chunks = 4